import React from 'react';
import {observer} from "mobx-react";
import {CheckboxComponent} from "../../basic-components/checkbox/checkbox.component";
import styled from "styled-components";
import {CardBox} from "../../basic-components/card/card.box";
import {
    IFlightSearchControllerViewModel,
} from "../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import {PsoUserOptionsEnum} from "../../services/flight-search/flight-search-controller/pso.enums";
import {IPsoMarket} from "../../services/stations/pso-market.interface";


const CheckBoxContainer = styled(CardBox)`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    gap: ${props => props.theme.spacing.flexGap16};
    box-shadow: none;
    border: none;
`

const CheckBoxLabel = styled.div`
    flex-grow: 1;
    
`


interface PsoUserOptionComponentProps {
    optionValue: PsoUserOptionsEnum;
    searchController: IFlightSearchControllerViewModel;
    psoMarket: IPsoMarket;
    className?: string;
}

export const PsoUserOptionComponent: React.FC<PsoUserOptionComponentProps> = observer((props) => {
    const searchController = props.searchController;
    const psoMarket = props.psoMarket;

    const onClick = () => {
        if(props.optionValue === searchController.psoUserOption) {
            searchController.psoUserOption = PsoUserOptionsEnum.None;
        } else {
            searchController.psoUserOption = props.optionValue;
        }
    }

    const getLabel = () => {
        return psoMarket.translations.getPsoUserOptionTranslation(props.optionValue);
    }


    return (
        <CheckBoxContainer className={props.className}
                           onClick={onClick}>
            <CheckboxComponent checked={searchController.psoUserOption === props.optionValue}
                               isReadOnly={true}/>
            <CheckBoxLabel>
                {getLabel()}
            </CheckBoxLabel>
        </CheckBoxContainer>
    )
});
